import { baseCellStyles } from '../cells.consts';
import { ITableStickyColumn } from '../../table.interfaces';
import { Menu, MuiTableCell, styled } from '../../../base-components';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    ![
        'stickyColumn',
        'rowStickyWidths',
        'columnIndex',
        'isSelected',
        'isHeaderCell',
    ].includes(prop as string);

export const StyledTableCell = styled(MuiTableCell, {
    shouldForwardProp: customShouldForwardProp,
})<{
    alignment: string;
    stickyColumn?: ITableStickyColumn;
    rowStickyWidths?: Array<number>;
    columnIndex?: number;
    isHeaderCell?: boolean;
}>(({
    theme,
    alignment: alignment,
    stickyColumn: stickyColumn,
    rowStickyWidths: rowStickyWidths,
    columnIndex: columnIndex,
    isSelected: isSelected,
    isHeaderCell: isHeaderCell,
}) => {
    const baseStyles = baseCellStyles(
        theme,
        alignment,
        stickyColumn,
        rowStickyWidths,
        columnIndex,
        isSelected
    );
    return {
        ...baseStyles,
        textAlign: 'center',
        backgroundColor: isHeaderCell ? theme.palette.common.white : undefined,
    };
});

export const StyledMenu = styled(Menu)(({ theme }) => {
    return {
        '& .MuiPaper-root': {
            borderRadius: theme.spacing(0.5),
            marginInline: '-4px',
            minWidth: 180,
            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
            '& .MuiMenu-list': {
                padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
                fontSize: 14,
                padding: '8px 16px',
                '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                },
            },
        },
    };
});
